import { Product } from "../../../../appData/productData"
import BottomSheet from "../../../../components/BottomSheet/BottomSheet"
import PrimaryButton from "../../../../components/PrimaryButton/PrimaryButton"
import { useMultiStep } from "../../../../context/multiStepContext"
import { usePurchase } from "../../../../context/purchaseContext"
import useStrings from "../../../../localization/useStrings"
import { formatCurrency, formatProductPrice } from "../../../../utils/utils"
import styles from "./PurchasePaywallSheet.module.scss"

const PurchasePaywallSheet = () => {
  const purchaseState = usePurchase().state
  const purchaseActions = usePurchase().actions

  const { state, actions } = useMultiStep()
  const product = state.yearlySelected
    ? purchaseState.selectedPlan.yearlyProduct
    : purchaseState.selectedPlan.monthlyProduct

  const price = formatProductPrice(product)

  const strings = useStrings()
  const ctaTitle = state.yearlySelected
    ? strings.multistep.startFreeWeek
    : strings.animated.cta
  const footerTitle = state.yearlySelected
    ? strings.multistep.footerTitle(price)
    : strings.multistep.footerMonthlyTitle(price)

  return (
    <BottomSheet
      visible={state.showBottomSheet}
      containerClassName={styles.sheetContainer}
      onClickOutside={() => {
        actions.setShowBottomSheet(false)
      }}
    >
      <div className={styles.container}>
        <label className={styles.title}>{strings.animated.title}</label>
        <PlanButton
          selected={state.yearlySelected}
          headerTitle={strings.multistep.headerTitle}
          product={purchaseState.selectedPlan.yearlyProduct}
          monthlyProduct={purchaseState.selectedPlan.monthlyProduct}
        />
        <PlanButton
          selected={!state.yearlySelected}
          product={purchaseState.selectedPlan.monthlyProduct}
          monthlyProduct={purchaseState.selectedPlan.monthlyProduct}
        />
        <PrimaryButton
          className={styles.cta}
          onClick={() => {
            if (state.yearlySelected) {
              purchaseActions.purchaseYearly()
            } else {
              purchaseActions.purchaseNoTrialMonthly()
            }
          }}
        >
          {ctaTitle}
        </PrimaryButton>
        <label className={styles.footerTitle}>{footerTitle}</label>
      </div>
    </BottomSheet>
  )
}

interface PlanButtonProps {
  selected: boolean
  headerTitle?: string
  product: Product
  monthlyProduct: Product
}

const PlanButton = (props: PlanButtonProps) => {
  const { state, actions } = useMultiStep()

  const globalStrings = useStrings()
  const strings = useStrings().multistep
  const yearly = props.product.duration == "yearly"
  const title = yearly ? strings.anual : strings.monthly

  const monthlyPrice = yearly ? props.product.price / 12 : props.product.price
  const formattedMonthlyPrice = formatCurrency(
    monthlyPrice,
    props.product.priceLocale
  )

  const priceDetail = yearly
    ? strings.yearlyPrice(formatProductPrice(props.product))
    : strings.noTrial
  const strikePrice = yearly
    ? formatCurrency(
        props.monthlyProduct.price * 12,
        props.product.priceLocale
      ) + "  "
    : ""

  return (
    <button
      className={`${styles.planButton} ${
        props.selected ? styles.selected : ""
      } ${props.headerTitle ? styles.hasHeader : ""}`}
      onClick={() => {
        actions.setYearlySelected(yearly)
      }}
    >
      {props.headerTitle && (
        <div className={styles.planHeader}>{props.headerTitle}</div>
      )}
      <div className={styles.planContent}>
        <div className={styles.planLeft}>
          <label className={styles.planTitle}>{title}</label>
          <label className={styles.planPriceDetail}>
            <label className={styles.strikeThrough}>{strikePrice}</label>
            {priceDetail}
          </label>
        </div>
        <div className={styles.planRight}>
          {globalStrings.monthlyPrice(formattedMonthlyPrice)}
        </div>
      </div>
    </button>
  )
}

export default PurchasePaywallSheet
